import { render, staticRenderFns } from "./ImageExpansion.vue?vue&type=template&id=0ac61892&scoped=true&lang=pug&"
import script from "./ImageExpansion.vue?vue&type=script&lang=ts&"
export * from "./ImageExpansion.vue?vue&type=script&lang=ts&"
import style0 from "./ImageExpansion.vue?vue&type=style&index=0&id=0ac61892&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac61892",
  null
  
)

export default component.exports